import gql from 'graphql-tag';

export const GET_VENUE_TYPE = gql`
  {
    venueType @client
  }
`;

export const GET_SHOW_DELTAS = gql`
  {
    showDeltas @client
  }
`;

export const GET_CASHBACK_SEGMENT = gql`
  {
    cashbackSegment @client
  }
`;

export const GET_KEY_METRICS = gql`
  fragment keyMetric on KeyMetric {
    amount
    amountCleared
    previousAmount
    nonClearedPending
  }

  query GetKeyMetrics($params: KeyMetricsInput) {
    keyMetrics(params: $params) {
      transactionCount {
        ...keyMetric
      }

      aov {
        ...keyMetric
      }

      frequency {
        ...keyMetric
      }

      revenue {
        ...keyMetric
      }

      lift {
        ...keyMetric
      }

      roas {
        ...keyMetric
      }

      attribution {
        ...keyMetric
      }
    }
  }
`;

export default GET_KEY_METRICS;
